// hooks.ts
import { useState } from "react";
import { SelectChangeEvent } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setServerConfig } from "../../../../store/api/admin/reducers";
import { IConfigureServer, resetConfigureServer } from "../../../../store/api/admin/types";
import { AppState } from "../../../../store";

export const useConfigureServers = () => {
  const dispatch = useDispatch();
  const serverConfig = useSelector((state: AppState) => state.admin.serverConfig);
  const [error, setError] = useState<Record<string, string>>({});
  const [touched, setTouched] = useState<Record<string, boolean>>({});
  
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    dispatch(setServerConfig({ ...serverConfig, [name]: value }));
  };

      
  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const { name, value } = event.target;
    dispatch(setServerConfig({ ...serverConfig, [name]: value }));
    if (value) {
      setError((prev) => ({ ...prev, [name]: '' }));
    }
  };

      const handleBlur = (fieldName: string, requiredMessage: string) => {
        setTouched((prev) => ({ ...prev, [fieldName]: true }));
        
        if (!serverConfig[fieldName]) {
          setError((prev) => ({ ...prev, [fieldName]: requiredMessage }));
        }
      };
  
  return {
    handleSelectChange,
    handleOnChange,
    serverConfig,
    handleBlur,
    error, 
    touched
  };
};